import React from 'react'
import { ModalContent, Button, Modal } from '@boulevard/blvd-ui'

interface IntegrationProps {
  open: boolean
  header: string
  content: string
  onYes: () => any
  onNo: () => any
}

export const ModalComponent: React.FC<IntegrationProps> = props => {
  return (
    <Modal
            size="small"
            open={props.open}
    >
      <ModalContent
                header={props.header}
                footer={
                  (
                    <>
                      <Button
                                onClick={() => props.onNo()}
                                theme="tertiary-transparent"
                      >
                          Cancel
                      </Button>
                      <Button onClick={() => props.onYes()} theme="primary">
                          Uninstall
                      </Button>
                    </>
                  )
                }
      >
        <p style={{ marginTop: 0, marginBottom: 0 }}>
          {props.content}
        </p>
      </ModalContent>
    </Modal>
  )
}
